export default __webpack_public_path__ + "static/media/DAIF_Infra_Screen1.d26c317b.mp4";